export const position_static =`
.position-static {
    position: static !important;
  }
`;
export const position_relative =`
  .position-relative {
    position: relative !important;
  }
`;
export const position_absolute =`
  .position-absolute {
    position: absolute !important;
  }
`;
export const position_fixed =`
  .position-fixed {
    position: fixed !important;
  }
`;
export const position_sticky =`
  .position-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
  }
`;
export const fixed_top =`
  .fixed-top {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030;
  }
`;
export const fixed_bottom =`
  .fixed-bottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030;
  }
`;
export const sticky_top =`
  @supports ((position: -webkit-sticky) or (position: sticky)) {
    .sticky-top {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 1020;
    }
  }
`;